import { createCollectible, type EntityInstance } from '@md/engine';
import type { EntityDef } from '@md/shared';
import { MAG, POLO } from '../characters.js';
import { BoltDefSchema } from './schemas.js';

/**
 * Boulon (concept §2, §4.2) : le collectible générique du moteur, habillé aux
 * couleurs du duo. Rouge = Polo (joueur 0), bleu = Mag (joueur 1). Les ramasser
 * tous vaut la 2ᵉ étoile.
 */
export function createBolt(def: EntityDef): EntityInstance {
  const cfg = BoltDefSchema.parse(def);
  const red = cfg.color === 'red';
  return createCollectible(
    { type: 'collectible', x: cfg.x, y: cfg.y, ...(cfg.id === undefined ? {} : { id: cfg.id }) },
    { type: 'bolt', player: red ? 0 : 1, tint: red ? POLO.tint : MAG.tint },
  );
}
